module.exports = __webpack_public_path__ + "static/media/Halloween.df13236f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/Halloween.png
// module id = 1338
// module chunks = 3